export enum AppError{
    NOT_FOUND_CONTENT = 'NOT_FOUND_CONTENT',
    NOT_FOUND_PAGE = 'NOT_FOUND_PAGE',
    APP = "APP",
}